module.exports = __webpack_public_path__ + "static/media/playstore.0c4080f4.png";